// extracted by mini-css-extract-plugin
export default {"main":"regularclean_main__Mz5Ks"};